"use client";

import React from "react";
import { Loader, Mail, Check } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
export default function NewsletterSignup() {
  return <section id="iscriviti-alla-newsletter" className="dark bg-sidebar text-sidebar-foreground border-y border-primary/30 py-12 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50" />
      
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-12">
          {}
          <div className="lg:w-1/3 space-y-4">
            <div className="flex items-center gap-3 text-primary mb-2">
              <Mail className="size-6" />
              <span className="text-sm font-mono uppercase tracking-wider font-semibold">
                Newsletter
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">
              Resta Aggiornato
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Ricevi approfondimenti tecnici, news sulla cybersecurity e guide per l'ottimizzazione dell'infrastruttura direttamente nella tua inbox.
            </p>
          </div>

          {}
          <div className="lg:w-2/3 w-full bg-sidebar-accent/30 p-6 rounded-lg border border-sidebar-border backdrop-blur-sm">
            <FormProvider formId="newsletter_signup_blog" sectionName="newsletter-signup" defaultValues={{
            first_name: "",
            email: "",
            company: "",
            consent: false
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            },
            consent: {
              required: true
            }
          }} submitText="Iscriviti Ora" successMessage="Grazie per l'iscrizione! Ti abbiamo inviato una email di conferma." errorMessage="Si è verificato un errore. Riprova più tardi.">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-8 text-center space-y-4 animate-in fade-in zoom-in duration-300">
        <div className="size-12 rounded-full bg-primary/20 flex items-center justify-center text-primary">
          <Check className="size-6" />
        </div>
        <h3 className="text-xl font-semibold text-white">Iscrizione Completata</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {}
        <FormField control={control} name="first_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sidebar-foreground/80">Nome (Facoltativo)</FormLabel>
              <FormControl>
                <Input placeholder="Mario" {...field} className="bg-sidebar-accent/50 border-sidebar-border focus-visible:ring-primary" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sidebar-foreground/80">Azienda (Facoltativo)</FormLabel>
              <FormControl>
                <Input placeholder="Nome Azienda" {...field} className="bg-sidebar-accent/50 border-sidebar-border focus-visible:ring-primary" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-start">
        {}
        <FormField control={control} name="email" rules={{
        required: "L'email è obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email non valida"
        }
      }} render={({
        field
      }) => <FormItem className="w-full">
              <FormLabel className="text-sidebar-foreground/80">Indirizzo Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="mario.rossi@example.com" {...field} className="bg-sidebar-accent/50 border-sidebar-border focus-visible:ring-primary" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <div className="pt-0 md:pt-8">
          <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-semibold shadow-[0_0_15px_rgba(6,182,212,0.3)]">
            {isSubmitting ? <>
                <Loader className="mr-2 size-4 animate-spin" />
                Invio...
              </> : "Iscriviti"}
          </Button>
        </div>
      </div>

      {}
      <FormField control={control} name="consent" rules={{
      required: "È necessario acconsentire per procedere"
    }} render={({
      field: {
        value,
        onChange,
        ...field
      }
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md p-2 -ml-2">
            <FormControl>
              <input type="checkbox" checked={value} onChange={onChange} className="mt-1 size-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 accent-primary cursor-pointer" {...field} />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-xs text-muted-foreground font-normal cursor-pointer">
                Acconsento al trattamento dei dati personali per l'invio della newsletter.
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded text-sm text-destructive">
          {submitError}
        </div>}
    </Form>;
}